import {InitPage} from "../../index";
import Highcharts from "highcharts";
import "highcharts/modules/accessibility";
import "highcharts/modules/exporting";
import "highcharts/modules/export-data";
import "highcharts/modules/series-label";
import * as Toastr from "toastr";

declare var saveProductionInCard;
export class ElcProductionCharts {
    constructor() {

        // @ts-ignore
        //Chart1

        // @ts-ignore
        //Chart2

        // @ts-ignore
        //Chart3

        let _this = this;
        $("#save-knowledge-box").on('click', function(){
            _this.saveKnowledgeBox();
        });

        $("#production_variance_reason").on('change', function(){
            $.ajax({
                url: $("#production_variance_reason").data("path"),
                data: { variance_reason: $("#production_variance_reason").val() },
                method: "PUT"
            }).then((response) => {
                if (response.success == "ok") {
                    Toastr.success('Variance Reason saved', "Saved");
                } else {
                    Toastr.error(response.error, "Error");
                }
            });
        });

    }

    saveKnowledgeBox() {
        $.ajax({
            url: saveProductionInCard,
            data: { elc_production_params: {
                knowledge_box: $("#knowledge-box").val() } },
            method: "PUT"
        }).then((response) => {
            if (response.success == "ok") {
                Toastr.success('Knowledge Box Entry Saved', "Saved");
            } else {
                Toastr.error(response.error, "Error");
            }
        });
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("chart", () => {
            const c = new ElcProductionCharts();
        });
    });
}
